module.exports = __webpack_public_path__ + "img/landing_content_example_1.f8df5e36.png";